export const constants = {
	buttons: {
		buttonSubmitDefaultText: 'Submit',
		BUTTON_CLEAR_DEFAULT_TEXT: 'Clear',
		btnPrimaryClass: 'btn-primary',
		btnSecondaryClass: 'btn-secondary',
		btnDangerClass: 'btn-danger',
		btnLinkClass: 'btn-link',
		btnBorderlessClass: 'btn-borderless'
	}
};
